import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { monetate } from '@grandvisionhq/svc-monetate';
import { createImpressionEvent, createImpressionObject } from '../Events/ProductListingPageEvents.js';
import { createInteractionEvent } from '../Events/ProductPromotionEvents.js';

const usePlpDatalayerEvents = ()=>{
    const { currency  } = useIntl();
    const { isMonetateProductDataEnabled  } = useFeatureToggles();
    const impressionEvent = createImpressionEvent(currency);
    const { atfEcommerce: { ecommerce: { impressions  } ,  } ,  } = impressionEvent;
    const addImpressionEvent = React.useCallback((product, position)=>{
        impressions.push(createImpressionObject(product, position));
    }, []);
    const trackMonetateImpressions = (products)=>{
        monetate().trackProductListing(isMonetateProductDataEnabled ? products.map((product)=>({
                productId: product.id,
                sku: product.masterVariant.sku || ''
            })
        ) : []);
    };
    const pushImpressionsToDatalayer = ()=>{
        DataLayer.pushEvent(impressionEvent);
    };
    const pushProductClickToDatalayer = React.useCallback((product, position)=>{
        var ref;
        DataLayer.pushEvent(createInteractionEvent(product, position, `category: ${(ref = product.productType.obj) === null || ref === void 0 ? void 0 : ref.name}`, currency));
    }, []);
    return {
        addImpressionEvent,
        trackMonetateImpressions,
        pushImpressionsToDatalayer,
        pushProductClickToDatalayer
    };
};

export { usePlpDatalayerEvents };
//# sourceMappingURL=use-plp-datalayer-events.js.map
